import * as api from 'app/shared/api';
import { Dispatch } from 'redux';
import { Action } from './store/actionTypes';
import { pageLoaded } from './store/actions';
import { School, Centre, Country, Product, PricingYearId } from "app/shared/model";
import { notifyPricelistPageReady } from 'app/shared/division/pricelistPageEvents';

type PricelistData = {
    schoolList: School[],
    centreList: Centre[],
    countryList: Country[],
    productList: Product[],
    pricingYearsList: PricingYearId[]
}

export async function loadPage(dispatch: Dispatch<Action>) : Promise<void> {
    return await fetchServerData()
    .then(x => {
        dispatch(pageLoaded(x.schoolList, x.centreList, x.countryList, x.productList, x.pricingYearsList));
        notifyPricelistPageReady();
    });
}

async function fetchServerData() : Promise<PricelistData> {
    
    const schools = await api.getAllSchools();
    const centres = await api.getAllCentres()
    const countries = await api.getAllCountries()
    const products = await api.getAllProducts(true);
    const pricingYears = await api.getAllPricingYears();

    return Promise.all([schools, centres, countries, products, pricingYears])
    .then(serverData => {
        const schoolList = serverData[0] ?? [];
        const centreList = serverData[1] ?? [];
        const countryList = serverData[2] ?? [];
        const productList = serverData[3] ?? [];
        const pricingYearsList = serverData[4] ?? [];

        return {schoolList, centreList, countryList, productList, pricingYearsList};
    });
}